import {
  connect,
} from 'react-redux';
import {
  withTranslation,
} from 'react-i18next';

import EntriesSectionView from './EntriesSectionView';

// Types
import type {
  $State,
} from '../../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './EntriesSectionView';

const mapStateToProps = ({
  auth,
  main,
}: $State): $StateProps => ({
  auth,
  main,
});

const mapDispatchToProps = (): $DispatchProps => Object.freeze({
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(EntriesSectionView);

const TranslatedComponent = withTranslation()(ConnectedComponent);

const Component = TranslatedComponent;

export default Component;
